import { Link } from "react-router-dom";

const PublishedVersions = ({versions, actual_id}) => {
  return (
    <div className="published-versions">
        <div className="published-versions-title">
          <h2>Opublikowane wersje</h2>
        </div>

        <table className="published-versions-table">
            <thead>
                <tr>
                    <th>Numer</th>
                    <th>Nazwa dokumentu</th>
                    <th>Status</th>
                    <th>Wersja</th>
                    <th>Data utworzenia</th>
                    <th>Data modyfikacji</th>
                    <th>Data publikacji</th>
                    <th>Akcja</th>
                </tr>
            </thead>
            <tbody>
            {versions.map((ver, index) => (
                <tr key={index}>
                    <td>{ver.CARD_NUMBER}</td>
                    <td>{ver.NAME}</td>
                    <td>Opublikowany</td>
                    <td>{ver.VERSION}</td>
                    <td>{ver.CREATION_DATE}</td>
                    <td>{ver.MODIFICATION_DATE}</td>
                    <td>{ver.PUBLISH_DATE}</td>
                    <td>{actual_id == ver.ID_CARD ? ("Aktualna"):(<Link to={`/dokument/${ver.ID_CARD}`}>Podgląd</Link>)}</td>
                </tr>
            ))}
            </tbody>
        </table>
    </div>
  )
}

export default PublishedVersions